import { Tooltip } from "@mantine/core";
import { IconPaperclip } from "@tabler/icons-react";

export function SystemEmailAttachmentIndicator() {
  return (
    <Tooltip label="Includes an attachment">
      <IconPaperclip
        aria-label="Includes an attachment"
        color="var(--mantine-color-dimmed)"
        size={16}
      />
    </Tooltip>
  );
}
